import React from 'react';
import { observer } from 'mobx-react-lite';
import { Modal } from 'antd';
import SomeThingWrongPage from './SomeThingWrongPage';
import { storeBowser } from '@Stores/StoreBowser';

const SomeThingWrongModal = observer(props => {
    const { modal1Visible } = props
    return (
        <Modal
            centered
            visible={modal1Visible}
            footer={null}
            closable={false}
            width={(() => {
                if (storeBowser.isDesktop()) {
                    return 840
                } else if (storeBowser.isTablet()) {
                    return 673
                } else if (storeBowser.isMobile()) {
                    return 320
                } else {
                    return 416
                }
            })()}
            wrapClassName='something-wrong--modal'
        >
            <SomeThingWrongPage />
        </Modal>
    );
})

export default SomeThingWrongModal;